import { AxiosInstance } from 'axios';
import { TopicsRepository } from '@/model/repository/manager/topics/TopicsRepository';
import { serializeTopicsRequestParams } from './serializeTopicsRequestParams';

export default (Repository: AxiosInstance) =>
  (resource: string): TopicsRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
    index_arrFmtRpeat(payload) {
      return Repository.get(`${resource}`, {
        params: payload,
        paramsSerializer: serializeTopicsRequestParams,
      });
    },
  });
